module.exports = __webpack_public_path__ + "img/rock-huge-13.43f45544.png";